<template>
  <div tabindex="1" id="pregunta-select" role="alert" class="activ-deci animated fadeIn light-dark-int" :style="estilos">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    selWidth: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      estilos: {
        width: this.selWidth + "px"
      }
    };
  }
};
</script>


<style lang="scss" scoped>
@import "../../sass/helpers/mixins";
@import "../../sass/helpers/variables";
.activ-deci {
  min-height: 100px;
  border-radius: 5px;
  @include shadow(0 2px 10px #555);
  padding: 5px;
  font-size: 1rem;
  p{
    margin: 0;
  }
}
</style>





// WEBPACK FOOTER //
// ActividadDeciSelec.vue?c9103892